<script setup lang="ts">
import { defineEmits } from 'vue';
import LogoHeaderColor from '@/assets/images/svg/logo-header-color.svg';

const emit = defineEmits(["close-mobile-menu"]);

const closeMobileMenu = () => {
  emit('close-mobile-menu');
}

const menuText = await queryContent('/menu').findOne();
const navItems = menuText.navItems;
</script>

<template>
  <div id="nav-mobile" class="modal header-mobile modal--fullscreen">
    <div class="modal__content">
      <div class="container">
        <div class="header-mobile__content align-items-center">
          <a href="#" class="header-mobile__logo" aria-label="Логотип компании">
            <LogoHeaderColor />
          </a>
          <button type="button" class="btn-icon navbar-close" @click="closeMobileMenu" />
        </div>
        <nav class="header-mobile__nav">
          <ul class="nav">
            <li v-for="(item, index) in navItems" :key="index" class="nav__item" @click="closeMobileMenu">
              <a :href="`#${item.link}`" class="nav__link">
                {{ item.title }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.header-mobile {
  &__content {
    display: flex;
    justify-content: space-between;
    padding: 26px 0;

    @media (max-width: $mobile) {
      padding: 12px 8px;
    }
  }

  &__logo {
    display: flex;
    align-items: center;
    width: 234px;

    @media (max-width: $large) {
      width: 223px;
    }

    @media (max-width: $medium) {
      width: 188px;
    }

    @media (max-width: $mobile) {
      width: 145px;
    }
  }

  .navbar-close {
    background-image: url('assets/images/svg/icon-close-dark.svg');
  }

  &__nav {
    padding: 42px 0;
    text-align: center;
    margin-bottom: 9px;

    .nav {
      &__link {
        display: block;
        padding: 20px 0;
        font-size: 18px;
      }
    }
  }
}
</style>
